import p from"styled-components";const t=p.div`
	display: grid;
	grid-template-columns: 240px 1fr 280px;
	height: calc(100% - 75px);
`;export{t as ContentContainer};
